import React, {Component, Fragment} from 'react';
import {withApollo} from 'react-apollo';
import styled from 'styled-components';
import LogoutIcon from '../../assets/icons/logout.svg';
import SleepIcon from '../../assets/icons/sleep.svg';
import {logout} from '../../utils/auth';
import FlatButton from '../common/FlatButton';
import ConfirmModal from '../app/ConfirmModal';

const Button = styled(FlatButton)`
  height: 100%;
  padding: 0;
  margin: 0 ${({theme}) => theme.spacingHorizontal()};
`;

const Icon = styled.img`
  height: 30px;
  width: 32px;
`;

class ToolbarButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmLogoutModalVisible: false,
    };
  }

  onLogout = () => {
    logout(this.props.client);
  };

  onGuestMode = () => {
    this.props.history.push('/guest');
  };

  toggleModal = () => {
    const {confirmLogoutModalVisible} = this.state;
    this.setState({
      confirmLogoutModalVisible: !confirmLogoutModalVisible,
    });
  };

  render() {
    return (
      <Fragment>
        <Button onClick={this.onGuestMode}>
          <Icon src={SleepIcon} />
        </Button>
        <Button onClick={this.toggleModal}>
          <Icon src={LogoutIcon} />
        </Button>
        <ConfirmModal
          isVisible={this.state.confirmLogoutModalVisible}
          confirm={this.onLogout}
          cancel={this.toggleModal}
          title={'Abmelden'}
          question={'Abmelden? Sind Sie sich sicher?'}
        />
      </Fragment>
    );
  }
}

export default withApollo(ToolbarButtons);
